import { api } from 'app/config/apiConfig';
import { PaginatedBoxOccupancyWithStatistic } from '../model/types';

interface Params {
  warehouseId?: string | string[];
  ignoreUnstartedContracts?: boolean;
  ignoreClosedContracts?: boolean;
  isApplicable?: boolean;
  statusRefDate?: string;
  orderBy?: string;
}

export const getWarehousesBoxesOccupancyApi = api.injectEndpoints({
  endpoints: (build) => ({
    getWarehousesBoxesOccupancy: build.query<PaginatedBoxOccupancyWithStatistic, Params>({
      query: (args) => ({
        url: '/warehouses/statistics/boxes/occupancy',
        params: args,
      }),
    }),
  }),
});

export const { useGetWarehousesBoxesOccupancyQuery } = getWarehousesBoxesOccupancyApi;
